/*******************************************************************
* PAGE        : LogoutService
* REMARKS     :
* CREATED ON  : 08-07-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 08-07-2026
********************************************************************/

import { CMExpressAPILogoutUser } from './apiController';

// #region Component
const LogoutService = async (userIdentification) => {
  try {
    const response = await CMExpressAPILogoutUser({ userIdentification, isExistsUser: false });

    return response;
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong."
    };
  }
};
// #endregion

export default LogoutService;